import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { TransformCta } from './CtaButton';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-107" data-mp="1gcxo0dofypwm">
      <div className="mx-auto max-w-2xl" data-id="element-108" data-mp="1gauqz9ovfwie">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-navy-900 sm:text-4xl" data-id="element-109" data-mp="2e0ps7rlx2rdp">
          ❓ Preguntas Frecuentes
        </h2>

        <ul className="mt-8 space-y-3" data-id="element-110" data-mp="28zikfsjrxs71">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.q} className="overflow-hidden rounded-2xl border border-navy-800/10 bg-cream" data-id="element-111" data-mp="1z3ym6zhqmhf4" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left sm:px-5" data-id="element-112" data-mp="skqo54jic0sg">
                  <span className="text-[14px] font-bold leading-snug text-navy-900 sm:text-[16px]" data-id="element-113" data-mp="ug9bjvuvqecn">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-violet-600 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-114" data-mp="kiblr3xdg9hx" />
                </button>

                <AnimatePresence initial={false} data-id="element-115" data-mp="3sz6h7ybuarlz">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-116" data-mp="1sd8m9epvq7f">
                      <p className="px-4 pb-4 text-[13.5px] leading-relaxed text-navy-800/75 sm:px-5 sm:text-[15px]" data-id="element-117" data-mp="1ugkvw6jl40jt">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <TransformCta headline="¿Sin más dudas? Empieza tu Ruta hoy mismo." data-id="element-118" data-mp="1fsgjfkb4kl9h" />
      </div>
    </section>;
}